import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32ef2e3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AssignedContracts" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-3" }
const _hoisted_5 = { class: "flex items-center justify-end mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_attach_document_form = _resolveComponent("attach-document-form")!
  const _component_contract_form = _resolveComponent("contract-form")!
  const _component_d24_form = _resolveComponent("d24-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.is_attach)
      ? (_openBlock(), _createBlock(_component_attach_document_form, {
          key: 0,
          "contract-id": _ctx.state.contract_id_for_attach,
          loading: _ctx.state.is_attach_loading,
          onCancel: _ctx.cancelAttach,
          onSubmit: _ctx.attachDocument
        }, null, 8, ["contract-id", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.state.is_add_contract)
        ? (_openBlock(), _createBlock(_component_contract_form, {
            key: 0,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_add_contract = false)),
            onAdded: _ctx.onContractAdded
          }, null, 8, ["onAdded"]))
        : (_ctx.state.is_d24)
          ? (_openBlock(), _createBlock(_component_d24_form, {
              key: 1,
              onCancel: _ctx.toggleD24
            }, null, 8, ["onCancel"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_page_title, { title: "Подписанные договоры" }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_the_button, {
                    class: "primary small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.is_add_contract = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить договор ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_the_button, {
                    class: "primary small ml-2",
                    onClick: _ctx.toggleD24
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Отправить в Д24 ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_the_button, {
                    class: "primary text small ml-2",
                    onClick: _ctx.exportExcel,
                    loading: _ctx.state.contracts.is_loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Скачать в Excel ")
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"])
                ])
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.loadContracts(1)), ["prevent"])),
                class: "mt-6 bg-white border px-4 py-2"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_the_input, {
                    placeholder: "Номер договора",
                    value: _ctx.filters_state.number,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.number) = $event))
                  }, null, 8, ["value"]),
                  _createVNode(_component_the_input, {
                    placeholder: "БИН",
                    value: _ctx.filters_state.bin,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.bin) = $event))
                  }, null, 8, ["value"]),
                  _createVNode(_component_the_input, {
                    placeholder: "Название договора",
                    value: _ctx.filters_state.original_name,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.original_name) = $event))
                  }, null, 8, ["value"]),
                  _createVNode(_component_the_select, {
                    "can-deselect": "",
                    placeholder: "Компания",
                    loading: _ctx.data_state.companies.is_loading,
                    failed: _ctx.data_state.companies.is_failed,
                    "error-text": "При получении списка компаний произошла ошибка",
                    options: _ctx.data_state.companies.list,
                    value: _ctx.filters_state.company_id,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.company_id) = $event)),
                    "search-without-refresh": "",
                    onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page)))
                  }, null, 8, ["loading", "failed", "options", "value"]),
                  _createVNode(_component_the_select, {
                    "can-deselect": "",
                    placeholder: "Статус",
                    options: _ctx.CONTRACT_STATUSES,
                    value: _ctx.filters_state.status_ids,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.status_ids) = $event)),
                    multiselect: ""
                  }, null, 8, ["options", "value"]),
                  _createVNode(_component_the_select, {
                    "can-deselect": "",
                    placeholder: "Тип",
                    loading: _ctx.data_state.contract_types.is_loading,
                    failed: _ctx.data_state.contract_types.is_failed,
                    "error-text": "При получении списка типов произошла ошибка",
                    options: _ctx.data_state.contract_types.list,
                    value: _ctx.filters_state.type_ids,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters_state.type_ids) = $event)),
                    multiselect: "",
                    "infinite-scroll": "",
                    onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadContractTypes(_ctx.data_state.types.pagination.current_page))),
                    onLoadmore: _cache[10] || (_cache[10] = ($event: any) => (
                            _ctx.loadMoreContractTypes(_ctx.data_state.types.pagination.current_page + 1)
                        ))
                  }, null, 8, ["loading", "failed", "options", "value"]),
                  _createVNode(_component_the_select, {
                    "can-deselect": "",
                    placeholder: "Тип доп. документа",
                    loading: _ctx.data_state.contract_types_additional.is_loading,
                    failed: _ctx.data_state.contract_types_additional.is_failed,
                    "error-text": "При получении списка типов произошла ошибка",
                    options: _ctx.data_state.contract_types_additional.list,
                    value: _ctx.filters_state.additionalTypeIds,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters_state.additionalTypeIds) = $event)),
                    multiselect: "",
                    "infinite-scroll": "",
                    onRefresh: _cache[12] || (_cache[12] = ($event: any) => (
                            _ctx.loadContractTypesAdditional(_ctx.data_state.types.pagination.current_page)
                        )),
                    onLoadmore: _cache[13] || (_cache[13] = ($event: any) => (
                            _ctx.loadMoreContractTypesAdditional(
                                _ctx.data_state.types.pagination.current_page + 1
                            )
                        ))
                  }, null, 8, ["loading", "failed", "options", "value"]),
                  _createVNode(_component_the_select, {
                    "can-deselect": "",
                    placeholder: "Подразделение",
                    loading: _ctx.data_state.subdivisions.is_loading,
                    failed: _ctx.data_state.subdivisions.is_failed,
                    "error-text": "При получении списка подразделений произошла ошибка",
                    options: _ctx.data_state.subdivisions.list,
                    value: _ctx.filters_state.subdivision_id,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters_state.subdivision_id) = $event)),
                    onRefresh: _ctx.loadSubdivisions
                  }, null, 8, ["loading", "failed", "options", "value", "onRefresh"]),
                  _createVNode(_component_the_select, {
                    "can-deselect": "",
                    placeholder: "Наличие документа",
                    options: _ctx.DOCUMENT_OPTIONS,
                    "select-by": "key",
                    value: _ctx.filters_state.hasDocument,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters_state.hasDocument) = $event))
                  }, null, 8, ["options", "value"]),
                  _createVNode(_component_the_select, {
                    "can-deselect": "",
                    placeholder: "Пролонгация",
                    options: _ctx.RENEWAL_OPTIONS,
                    "select-by": "key",
                    value: _ctx.filters_state.isAutoRenewal,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filters_state.isAutoRenewal) = $event))
                  }, null, 8, ["options", "value"]),
                  _createVNode(_component_the_select, {
                    "can-deselect": "",
                    placeholder: "Услуги",
                    loading: _ctx.data_state.services.is_loading,
                    failed: _ctx.data_state.services.is_failed,
                    "error-text": "При получении списка произошла ошибка",
                    options: _ctx.data_state.services.list,
                    value: _ctx.filters_state.serviceIds,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filters_state.serviceIds) = $event)),
                    multiselect: "",
                    onRefresh: _ctx.loadServices
                  }, null, 8, ["loading", "failed", "options", "value", "onRefresh"])
                ]),
                _createVNode(_component_checkbox, {
                  class: "mt-3",
                  label: "Убрать переподписанные документы",
                  value: _ctx.filters_state.hasResignedContract,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.filters_state.hasResignedContract) = $event)),
                  "return-integer": ""
                }, null, 8, ["value"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_the_button, {
                    class: "second text small mr-2",
                    loading: _ctx.state.contracts.is_loading,
                    onClick: _ctx.resetFilters
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createTextVNode(" Сброс ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]),
                  _createVNode(_component_the_button, {
                    class: "primary text small",
                    loading: _ctx.state.contracts.is_loading,
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createTextVNode(" Поиск ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ], 32),
              _createElementVNode("div", _hoisted_8, [
                (
                        _ctx.state.contracts.is_failed && !_ctx.state.contracts.failure.error_state.is_cancel
                    )
                  ? (_openBlock(), _createBlock(_component_failed_fetch, {
                      key: 0,
                      loading: _ctx.state.contracts.is_loading,
                      text: "При получении списка договоров произошла ошибка",
                      "error-message": _ctx.state.contracts.failure.error_state.message,
                      "error-url": _ctx.state.contracts.failure.error_state.url,
                      "error-status": _ctx.state.contracts.failure.error_state.status,
                      onRefresh: _cache[20] || (_cache[20] = ($event: any) => (_ctx.loadContracts(_ctx.state.contracts.pagination.current_page)))
                    }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
                  : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                      key: 1,
                      loading: _ctx.state.contracts.is_loading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_table, {
                          loading: _ctx.state.contracts.is_loading,
                          columns: _ctx.ContractsColumns,
                          rows: _ctx.state.contracts.list,
                          "with-limit": "",
                          "pagination-limit": _ctx.filters_state.limit,
                          "pagination-total-items": _ctx.state.contracts.pagination.total_items,
                          "pagination-current-page": _ctx.state.contracts.pagination.current_page,
                          "pagination-total-pages": _ctx.state.contracts.pagination.total_pages,
                          onChangePage: _ctx.loadContracts,
                          onChangeLimit: _ctx.onLimitChange,
                          "is-columns-modal": ""
                        }, {
                          td: _withCtx(({ column, row }) => [
                            (column.key === 'number')
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: `/contracts/${row.id}`,
                                  target: "_blank",
                                  class: "AssignedContracts__link"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.number), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (column.key === 'services')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.getServicesStr(row.services)), 1)
                                  ], 64))
                                : (column.key === 'original_name')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key])), 1)
                                    ], 64))
                                  : (column.key === 'subdivision_name')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key])), 1)
                                      ], 64))
                                    : (column.key === 'date')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                          _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.date)), 1)
                                        ], 64))
                                      : (column.key === 'expiration_date')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                            _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.expiration_date)), 1)
                                          ], 64))
                                        : (column.key === 'createdAt')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                              _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.createdAt)), 1)
                                            ], 64))
                                          : (column.key === 'custom_company_name')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                                _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key])), 1)
                                              ], 64))
                                            : (column.key === 'documents')
                                              ? (_openBlock(), _createElementBlock("i", {
                                                  key: 8,
                                                  class: _normalizeClass(_ctx.getCheckOrTimesIcon(Boolean(row.path)))
                                                }, null, 2))
                                              : (column.key === 'prolongation')
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 9,
                                                    class: _normalizeClass(_ctx.getCheckOrTimesIcon(Boolean(row.is_auto_renewal)))
                                                  }, null, 2))
                                                : (column.key === 'status' && row.status && row.status_id)
                                                  ? (_openBlock(), _createBlock(_component_cheap, {
                                                      key: 10,
                                                      class: _normalizeClass(`small ${_ctx.ContractsStatusColors[row.status_id]}`)
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(row.status), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                                      _createTextVNode(_toDisplayString(row[column.key]), 1)
                                                    ], 64))
                          ]),
                          actions: _withCtx(({ row }) => [
                            _createVNode(_component_the_button, {
                              hint: "Прикрепить документ",
                              class: "primary extra-small mr-3",
                              onClick: ($event: any) => (_ctx.startAttach(row.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                      ]),
                      _: 1
                    }, 8, ["loading"]))
              ])
            ], 64))
    ])
  ], 64))
}